'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var utils_i18n_maybeFormatPrefixedMessage = require('../i18n/maybeFormatPrefixedMessage.js');
require('../i18n/maybeFormatMessage.js');

function intlAriaAttrs(intl, intlAriaKey) {
  var bindFormatIntl = utils_i18n_maybeFormatPrefixedMessage['default'](intl, intlAriaKey);
  return intlAriaKey ? {
    title: bindFormatIntl('TITLE'),
    'aria-details': bindFormatIntl('ARIA_DETAILS'),
    'aria-roledescription': bindFormatIntl('ARIA_ROLEDESCRIPTION'),
    'aria-label': bindFormatIntl('ARIA_LABEL')
  } : {};
}

exports.default = intlAriaAttrs;
//# sourceMappingURL=intlAriaAttrs.js.map
